var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAwesomeTooth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 114.285,
    viewBox: "0 0 100 114.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.1,21.484A28.905,28.905,0,0,0,78.565.565C71.38-1.3,64.5,1.7,58.668,6a14.907,14.907,0,0,1-2.344,1.223l6.321,4.065a3.571,3.571,0,1,1-3.864,6.007L36.347,2.866C31.726.444,26.664-.795,21.434.565A28.909,28.909,0,0,0,.9,21.484,29.278,29.278,0,0,0,5.7,46.134C10.909,53.18,12.99,61.459,13.8,70.1a238.375,238.375,0,0,0,4.674,31.321l1.741,7.578a6.79,6.79,0,0,0,13.216.121l7.694-30.9a9.14,9.14,0,0,1,17.75,0l7.694,30.9a6.79,6.79,0,0,0,13.216-.121l1.741-7.578A238.693,238.693,0,0,0,86.2,70.1C87,61.457,89.083,53.18,94.3,46.134A29.254,29.254,0,0,0,99.1,21.484Z",
    transform: "translate(0 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeTooth);
export default __webpack_public_path__ + "static/media/icon-awesome-tooth.2f5529554cd13ad8fdc253490b954598.svg";
export { ForwardRef as ReactComponent };